import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-consultancy-time',
  templateUrl: './consultancy-time.component.html',
})
export class DashboardV2ConsultancyTimeComponent {
  @Input() students: any[] = [];
  @Input() pagerLabel = '';
  @Input() pageLabel = '';
  @Input() loading = false;
  @Input() error = '';
  @Output() refresh = new EventEmitter<void>();
  @Output() profile = new EventEmitter<any>();
  @Output() whatsapp = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<number>();

  useDefaultAvatar(event: Event): void {
    const image = event.target as HTMLImageElement;
    const fallback = 'assets/imgs/default_avatar.png';

    if (image && !image.src.endsWith(fallback)) {
      image.src = fallback;
    }
  }
}
